export const BOOKING_VISIT_REASONS = [
	{ value: 'meeting', label: 'Встреча' },
	{ value: 'interview', label: 'Собеседование' },
];

export enum BOOKING_PASS_TYPES_KEYS {
	ENTRANCE_PARKING = 'entrance_parking',
	ENTRANCE = 'entrance',
	PARKING = 'parking',
}

export const BOOKING_PASS_TYPES_VALUES = {
	[BOOKING_PASS_TYPES_KEYS.ENTRANCE_PARKING]: 'На вход и парковку',
	[BOOKING_PASS_TYPES_KEYS.ENTRANCE]: 'На вход',
	[BOOKING_PASS_TYPES_KEYS.PARKING]: 'На парковку',
};

export const BOOKING_PASS_TYPES = [
	{
		value: BOOKING_PASS_TYPES_KEYS.ENTRANCE_PARKING,
		label: BOOKING_PASS_TYPES_VALUES[BOOKING_PASS_TYPES_KEYS.ENTRANCE_PARKING],
	},
	{
		value: BOOKING_PASS_TYPES_KEYS.ENTRANCE,
		label: BOOKING_PASS_TYPES_VALUES[BOOKING_PASS_TYPES_KEYS.ENTRANCE],
	},
	{
		value: BOOKING_PASS_TYPES_KEYS.PARKING,
		label: BOOKING_PASS_TYPES_VALUES[BOOKING_PASS_TYPES_KEYS.PARKING],
	},
];
